var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindowsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8947 18.9474V3.12947L39.9947 0V18.9474H17.8947ZM15.7895 3.42737L0 5.66316L0.0147368 18.9474H15.7895V3.42737ZM0.0115789 21.0526L15.7895 21.08V36.6505L0.0126316 34.4674L0.0115789 21.0526ZM17.8947 36.9421V21.0842L40 21.1221L39.9947 40L17.8947 36.9421Z",
    fill: "#00B0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsLogo);
export default __webpack_public_path__ + "static/media/windows-logo.e008e0453d1cd12afd41c8e7ecb951d9.svg";
export { ForwardRef as ReactComponent };